import { ExecuteAPIGet } from '../server-utils'
import { EndPoints } from '../endpoints'
import { kl_RegionModel } from '../../models/kl_region-model'

export const RegionUtils = {
  GetAll: async function GetAll() {
    return await ExecuteAPIGet<kl_RegionModel[]>(EndPoints.Region.GetAll)
  }
}
